import { keyframes } from '@emotion/react';
import { getFontSize } from '../../../../constants/fontSizes';

const slideInFromBottom = keyframes`
  from {
    transform: translateY(200%);
  }
  to {
    transform: translateY(0);
  }
`;

export const getTermsSectionStyles = (isInView) => {
  return {
    container: {
      display: 'flex',
      width: '100%',
      marginTop: '75px',
      transform: isInView ? 'translateY(0)' : 'translateY(200%)',
      ...(isInView && {
        animation: `${slideInFromBottom} 1.5s ease-out 0.3s forwards`,
      }),
      overflowY: 'hidden',
    },
    section1: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '20px',
    },
    linkText: {
      color: '#F3F3F3',
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(18),
      lineHeight: '20px',
      letterSpacing: '0%',
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationOffset: '0%',
      textDecorationThickness: '0%',
      cursor: 'pointer',
    },
    section2: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    copyrightText: {
      color: '#F3F3F3',
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: getFontSize(18),
      lineHeight: '20px',
      letterSpacing: '0%',
      textAlign: 'center',
    },
    section3: {
      display: 'flex',
      flexDirection: 'row',
      gap: '5px',
      justifyContent: {xs: 'center', lg: 'flex-end'},
      alignItems: 'center',
    },
    poweredByText: {
      color: '#F3F3F3',
      fontFamily: 'Lato',
      fontWeight: 400,
      fontStyle: 'Regular',
      fontSize: getFontSize(18),
      lineHeight: '20px',
      letterSpacing: '0%',
    },
    edgeGlobalText: {
      color: '#BCA08A',
      fontFamily: 'Lato',
      fontWeight: 700,
      fontStyle: 'Bold',
      fontSize: getFontSize(18),
      lineHeight: '20px',
      letterSpacing: '0%',
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationOffset: '0%',
      textDecorationThickness: '0%',
      cursor: 'pointer',
    },
  };
};
